import { type ReactNode, useLayoutEffect } from "react";
import { useCatalogStore } from "@/features/catalog/stores/catalogStore";
import { shouldInitializeCatalogLayout } from "@/features/catalog/utils/catalogLayoutRoute";
import { LoadingScreen } from "@/shared/ui/feedback/Loading";

interface CatalogLayoutInitializerProps {
  children: ReactNode;
  deferChildren: boolean;
  isDesktop: boolean;
}

interface CatalogLayoutGateProps {
  children: ReactNode;
  deferChildren: boolean;
  isLayoutInitialized: boolean;
}

export const CatalogLayoutInitializer: React.FunctionComponent<
  CatalogLayoutInitializerProps
> = ({ children, deferChildren, isDesktop }: CatalogLayoutInitializerProps) => {
  const isLayoutInitialized = useCatalogStore(
    (state) => state.isLayoutInitialized,
  );
  const initializeLayout = useCatalogStore((state) => state.initializeLayout);

  useLayoutEffect(() => {
    if (!shouldInitializeCatalogLayout(deferChildren, isLayoutInitialized)) {
      return;
    }
    initializeLayout(isDesktop);
  }, [deferChildren, initializeLayout, isDesktop, isLayoutInitialized]);

  return (
    <CatalogLayoutGate
      deferChildren={deferChildren}
      isLayoutInitialized={isLayoutInitialized}
    >
      {children}
    </CatalogLayoutGate>
  );
};

export const CatalogLayoutGate: React.FunctionComponent<
  CatalogLayoutGateProps
> = ({
  children,
  deferChildren,
  isLayoutInitialized,
}: CatalogLayoutGateProps) => {
  if (deferChildren && !isLayoutInitialized) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
};
